import React, { Component } from 'react';
import { compose } from 'recompose';
import { ProjectList, PersonalInfo, Subscription } from '../Account/index';
import Voucher from './Voucher/Voucher';
import Order from './Order/Order';
import Credit from './Credit/Credit';
import AddressBook from '../Address/AddressBook';
import { connectUserDetail } from '../Auth/UserDetailManager';
import config from '../../config';
import { saveState } from '../Common/localStorage';
import Avatar from './Avatar';
import Spinner from '../Common/Spinner';
import { withTranslation, HTMLTrans, TransLink } from '../Common/Translations';
import EPhotobook from './EPhotobook/EPhotobook';
import RemindMe from './RemindMe/RemindMe';
import withGlobalShippingCredit from '../GlobalShippingCredit/withGlobalShippingCredit';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import ShippingCreditExpiryModal from '../GlobalShippingCredit/ShippingCreditExpiryModal';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      store: {},
    };

    this._updatePersonalInfo = this._updatePersonalInfo.bind(this);
  }

  componentDidMount() {
    this.getUserDetail();
    this.getStoreInfo();
  }

  getUserDetail() {
    const userDetail = this.props.userDetail;
    if (userDetail === null) {
      $.get(`${config.api}/user`)
        .done((response) => {
          const userDetail = response.data.original.data;
          saveState('UserDetail', userDetail);
          this.props.setUserDetail(userDetail);
        })
        .fail(response => console.log('fail', response));
    }
    this.setState({ user: userDetail });
  }

  getStoreInfo() {
    $.get(`${config.localeApi}/store`)
      .done((response) => {
        this.setState({ store: response.data });
      })
      .fail(response => console.log('fail', response));
  }

  _handleInputChange(target) {
    const user = this.state.user;
    user[target.name] = target.value;
    this.setState({ user });
  }

  _updatePersonalInfo(data) {
    $.post(`${config.api  }/updateinfo`, data, (response) => {
      toastr.success(
        this.props.t("account.dashboard_updatepersonalinfo_success", "Updated"), '',
        { positionClass: 'toast-bottom-full-width' },
      );
      const payload = response.data;
      this.setState({ user: payload });
      saveState('UserDetail', payload);
      this.props.setUserDetail(payload);
    }).fail((response) => {
      toastr.error(
        this.props.t("account.dashboard_updatepersonalinfo_fail", "Failed"), '',
        { positionClass: 'toast-bottom-full-width' },
      );
    });
  }

  _getTabs() {
    const {
      userHeaderInfo,
      shippingCreditCurrency,
      shippingCreditBalance,
      shippingCreditNearestExpiry,
      globalShippingCreditEnabled,
      creditFaqUrl,
    } = this.props;

    const tabs = [
      {
        id: 'project',
        text: <HTMLTrans id="account.dashboard_projects">My Projects</HTMLTrans>,
        component: <ProjectList {...this.props} />,
      },
      {
        id: 'order',
        icon: 'fa-shopping-bag',
        text: <HTMLTrans id="account.dashboard_orders">My Orders</HTMLTrans>,
        component: <Order {...this.props} />,
      },
      {
        id: 'voucher',
        text: <HTMLTrans id="account.dashboard_vouchers">My Vouchers</HTMLTrans>,
        component: <Voucher {...this.props}/>,
      },
      {
        id: 'remind-me',
        text: <HTMLTrans id="account.dashboard_remind_me">Remind Me</HTMLTrans>,
        component: <RemindMe {...this.props} />,
      },
      {
        id: 'ephotobook',
        text: <HTMLTrans id="account.dashboard_ephotobook">Share It</HTMLTrans>,
        component: <EPhotobook {...this.props} />,
      },
      {
        id: 'personal',
        icon: 'fa-user',
        text: <HTMLTrans id="account.dashboard_accountinformation">Account Information</HTMLTrans>,
        component: <PersonalInfo user={this.state.user}
                                 updatePersonalInfo={this._updatePersonalInfo}
                                 {...this.props} />,
      },
      {
        id: 'address',
        icon: 'fa-send',
        text: <HTMLTrans id="account.dashboard_addressbook">Address Book</HTMLTrans>,
        component: <AddressBook {...this.props} />,
      },
    ];

    if (this.state.store.has_active_subscriptions) {
      tabs.splice(3, 0, {
        id: 'pass',
        text: <HTMLTrans id="account.dashboard_photobookpass">My Photobook Pass</HTMLTrans>,
        component: <Subscription globalShippingCreditEnabled={globalShippingCreditEnabled} />,
      });
    }

    if (this.props.globalShippingCreditEnabled) {
      tabs.splice(4, 0, {
        id: 'credit',
        text: <HTMLTrans id="account.dashboard_credits">My Credits</HTMLTrans>,
        component: <Credit
          storeCreditCurrency={this.state.store.currency.code}
          storeCreditBalance={userHeaderInfo.creditBalance}
          shippingCreditCurrency={shippingCreditCurrency}
          shippingCreditBalance={shippingCreditBalance}
          shippingCreditNearestExpiry={shippingCreditNearestExpiry}
          creditFaqUrl={creditFaqUrl}
        />,
      });
    }

    return tabs;
  }

  render() {
    const {
      routes,
      userHeaderInfo,
      globalShippingCreditEnabled,
      shippingCreditCurrency,
      shippingCreditBalance
    } = this.props;

    const { module = '' } = routes.slice(-1).pop();
    const currentHeader = this._getTabs().find(o => o.id === module);

    if (!currentHeader) {
      if (this.state.store.has_active_subscriptions === undefined || globalShippingCreditEnabled === undefined) {
        return (<Spinner/>);
      }
      window.location = '/account';
    }

    const tabHeaders = this._getTabs().map(tab =>
      <TransLink
        className={module == tab.id ? 'active' : ''}
        key={tab.id}
        url={ `/account/dashboard/${  tab.id}` }
        role="tab"
      >
        {tab.text}
        { module == tab.id && <i className="fa fa-chevron-right float-right mt-1" aria-hidden="true"/> }
      </TransLink>);

    const mobileHeaders = this._getTabs().map(tab =>
      <TransLink
        key={tab.id}
        className="dropdown-item"
        url={ `/account/dashboard/${  tab.id}` }
      >
        {tab.text}
      </TransLink>);

    const tabContents = this._getTabs().map(tab =>
      <div className={module == tab.id ? 'tab-pane h-100 fade show active' : 'tab-pane h-100 fade'} key={tab.id} id={tab.id} role="tabpanel">
        {tab.component}
      </div>);

    const avatar = <Avatar
      userHeaderInfo={userHeaderInfo}
      globalShippingCreditEnabled={globalShippingCreditEnabled}
      shippingCreditCurrency={shippingCreditCurrency}
      shippingCreditBalance={shippingCreditBalance}
    />;

    return (
      <div className="dashboard__component bg-gray-lighten-3 p-3 p-lg-6">
        <div className="container px-0">
          <div className="row">
            <div className="d-none d-lg-block col-lg-3">
              <nav className="nav nav-dashboard flex-column" role="tablist" aria-orientation="vertical">
                <div className="text-center pt-5 px-5 credit-balance">
                  {avatar}
                </div>
                {tabHeaders}
                </nav>
            </div>
            <div className="d-block d-lg-none col-12">
              <div className="text-center d-inline-block w-100 pt-3 pt-lg-5 mb-3 credit-balance bg-white text-primary">
                {avatar}
              </div>
              <div className="nav nav-dashboard-mobile">
                <a className="nav-menu"
                   id="navDashboardMobile"
                   data-toggle="dropdown"
                   aria-haspopup="true"
                   aria-expanded="false">
                  <h2 className="mb-0">
                    {currentHeader.text}
                    <i className="fa fa-chevron-down float-right"></i>
                  </h2>
                </a>
                <div className="dropdown-menu">
                  {mobileHeaders}
                  </div>
              </div>
            </div>

            {globalShippingCreditEnabled && <ShippingCreditExpiryModal />}

            <div className="col-lg-9 tab-content">
              {tabContents}
              </div>
          </div>
        </div>
        <div className='mb-6 mb-lg-5'></div>
      </div>
    );
  }
}

const enhance = compose(
  withTranslation('account'),
  connectUserDetail,
  withGlobalShippingCredit,
  connectUserHeaderinfo,
);

export default enhance(Dashboard);
export const undecorated = Dashboard;



// WEBPACK FOOTER //
// ./src/Account/Dashboard.js